const styles = theme => ({
  header: {
    color: 'var(--mcg-darkgray, #282F35)',
    /* Body/Body 2 */
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 24px */,
  },
  note: {
    color: 'var(--Gray-Darker, #838D98)',
    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  badgeLeft: {
    display: 'flex',
    padding: '4px 12px',
    alignItems: 'center',
    gap: '6px',
    borderRadius: '50px',
    background: 'var(--mcg-bg, #E3F3FF)',
  },
  badgeRight: {
    display: 'flex',
    padding: '4px 12px',
    alignItems: 'center',
    gap: '6px',
    borderRadius: '50px',
    border: '1px solid var(--Gray-Lighter, #E5E7EB)',
    background: 'var(--mcg-white, #FFF)',
  },
  description: {
    color: '#4B5563',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  dividerContainer: {
    width: '100%',
  },
  divider: {
    height: '1px',
    background: '#E5E7EB',
  },
  educationalText: {
    color: '#4B5563',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%' /* 21px */,
    marginRight: '4px',
  },
  headerSelect: {
    color: 'var(--mcg-dark, #002E47)',
    /* Button/Large */
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
  },
  selectContainer: {
    display: 'flex',
    padding: '20px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--12, 12px)',
    alignSelf: 'stretch',
    borderRadius: '12px',
    border: '1px solid var(--Gray-Lighter, #E5E7EB)',
    background: 'var(--mcg-white, #FFF)',
  },
  badgeContainer: {
    display: 'flex',
    gap: '12px',
  },
  badgeTitle: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
  },
  descriptionContainer: {
    width: '100%',
  },
  titleContainer: {
    width: '100%',
  },
  emptyState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    flexDirection: 'column',
    gap: '8px',
  },
  row: {
    display: 'grid',
    gap: '4px',
  },
  box: {
    width: '800px',
    height: '600px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  popover: {
    zIndex: '99999 !important',
  },
  pickerBg: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    width: 36,
    height: 36,
    background: '#f2f2f2',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  pickerSpan: {
    width: 24,
    height: 24,
    borderRadius: '10px',
    background: 'red',
  },
  boxIconButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: '1 0 0',
  },
})

export default styles
